import { cj } from 'src/utils/classNames';
import { useEffect } from 'react';

interface Props {
	durationMillis?: number;
}

/**
 * Renders a progress bar that fills in from left to right with the defined
 * duration, or the default duration if none passed (see the TW config).
 */
export default function TimedProgressBar({ durationMillis }: Props) {
	useEffect(() => {
		document.documentElement.style.setProperty(
			'--slide-in-from-left-duration',
			`${durationMillis}ms`
		);

		return () => {
			document.documentElement.style.removeProperty(
				'--slide-in-from-left-duration'
			);
		};
	}, [durationMillis]);

	return (
		<div className="relative h-1 w-full overflow-hidden">
			<div
				className={cj(
					// Extra 50px of width so the gradient "disappears" as the bar approaches the end.
					'absolute top-0 left-0 h-full w-[calc(100%+50px)]',
					'animate-slide-in-from-left [background:linear-gradient(to_right,var(--text-secondary)_0%,var(--button-secondary-bg-hover)_100%)]'
				)}
			/>
		</div>
	);
}
